export default __webpack_public_path__ + "static/media/Icons_Home_Grey Icon.44bcd4d6.svg";